renderSentryConfig("merkur");

function renderSentryConfig(name) {
  // Prüfen, ob bereits gerendert
  if (document.querySelector(`sentry-config[project-name="${name}"]`)) {
    return;
  }

  const template = document.getElementById(`sentry-config-${name}`);
  if (template) {
    const content = template.content.cloneNode(true);
    document.body.appendChild(content);
  }
}
